/**
 * Creates a session monitor that will automatically log the user out when his session expires.
 * The session monitor accepts an initial poll time, intended to be set to session expiration
 * during the login event. As the user interacts with Dataserver his session is extended automatically.
 * We always poll 1 second after the last known session expire time. If the session was extended we'll
 * get that in the response. If DataServer says the session expires, we logout.
 * Note this is a fairly permissive API; it assumes the users' session is good unless it receives
 * an explicit negative response from DataServer; errors, if they occur are ignored.
 * Also note that in the event an error we fall back to 5 minute polling.
 */
(function () {
  var module = namespace.create('leica.pi.auth.session');
  var auth = namespace.using('leica.pi.auth');

  var DEFAULT_POLL_INTERVAL = 5000;

  module.SessionMonitor = function ($http, parseResponseFn, initialInterval) {
    var nextPollInterval = initialInterval + 1000;
    var sessionTimer;

    if (!nextPollInterval) {
      return;
    }

    this.start = run;
    this.stop = function () {
      clearTimeout(sessionTimer);
      sessionTimer = null;
    };

    function run () {
      if (sessionTimer) {
        console.warn ('Session Timer is already running');
        return;
      }
      sessionTimer = setTimeout(function () {
        sessionTimer = null; // clear the timer so we know it's safe to iterate again
        $http.post('/Auth/Session/SessionActive.php')
          .then(checkSessionState, checkSessionState);
      }, nextPollInterval);
    }

    function checkSessionState (response) {
      try {
        var data = parseResponseFn(response);
        var result = data && data.Session;
        var sessionExpiresAt = data && data.TokenExpirationTime;

        // Only log out if DataServer explicitly tells us to
        if (result === 'Inactive') {
          return auth.logoff(auth.consts.SESSION_TIMEOUT);
        }

        // set next poll interval
        nextPollInterval = DEFAULT_POLL_INTERVAL;
        if (sessionExpiresAt) {
          sessionExpiresAt = new Date(sessionExpiresAt).getTime();
          var now = Date.now();
          if (sessionExpiresAt > now) {
            nextPollInterval = sessionExpiresAt - now + 1000;
          }
        }
      } catch (e) {
        // swallow errors and keep polling.
      }
      run();
    }
  }
}());
